import React, { useState, useEffect } from "react";
import uuid from "react-uuid";
import { IVersion } from "../../../utils/fetchers/types";
import menuIcon from '../../../assets/icons/menu.svg'

import styles from './Nav.module.css'

type TNav = {
  versions: IVersion[];
  currentVersion: string;
  isTableShow: boolean
}
const scrollToElement = (element: string): void => {
  const section = document.getElementById(`${element}`);
  section?.scrollIntoView({ behavior: 'smooth', block: 'start' });
};


const Nav: React.FC<TNav> = ({ isTableShow, versions, currentVersion }) => {

  const [showMenu, setShowMenu] = useState(false);

  const closeMenu = () => setShowMenu(false);
  const toogleMenu = () => setShowMenu(!showMenu);

  useEffect(() => {
    if (!isTableShow) closeMenu()
  },[isTableShow])

  return (
    <>
      <img
        className={`${styles.burgerMenuBtn} ${showMenu && styles.open}`}
        onClick={toogleMenu}
        src={menuIcon} alt="menu icon"
      />
      {
        showMenu
        &&
        <div
          onClick={closeMenu}
          className={styles.overlay}>
        </div>
      }
      <div className={`${styles.wrapper} ${styles.burgerMenu} ${showMenu && styles.open}`}>
        <div className={styles.sticky}>
          <div className={styles.heading}>
            Version:
          </div>
          {versions.map((version) =>
            <div
              key={uuid()}
              onClick={() => scrollToElement(version.version)}
              className={styles.item}>
              <div
                onClick={closeMenu}
                className={styles.itemText}>{version.version}
              </div>
              {(version.version === currentVersion)
                &&
                <div className={`${styles.label} ${styles.labelYourVersion}`}>Your Version</div>}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Nav;